// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input {
  display: flex;
  border-radius: 3px;
  height: 50px;
  box-shadow: 0px 0px 1px 1px rgba(128, 128, 128, 0.253);
  position: relative;
  font-size: 16px !important;
}
.input .input-icon {
  position: absolute;
  right: 5px;
  top: 12.5px;
  height: 25px;
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: grey;
}
.input .input-high {
  background-color: hwb(228deg 92% 6%);
  display: flex;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 3px 0px 0px 3px;
  justify-content: center;
}
.input input,
.input textarea {
  width: 100%;
  padding: 0px 15px;
  border: none;
  outline: none;
  font-size: 16px !important;
}
.input input::placeholder {
  font-weight: bold;
  color: rgba(128, 128, 128, 0.685);
}
.input .input-item:focus {
  box-shadow: 0px 0px 1px 1px rgb(37, 130, 236);
}
.input .input-error {
  box-shadow: 0px 0px 1px 1px rgb(243, 57, 57);
}
.input .input-item-borderRadius {
  border-radius: 3px;
}
.input .input-item-green {
  color: rgb(65, 158, 64);
  font-weight: bold;
}

.input-area {
  height: auto;
  min-height: 120px;
  max-height: 120px;
}
.input-area textarea {
  resize: none;
  padding: 10px 15px;
}

.select .ant-select-selector {
  min-height: 50px !important;
  border-radius: 3px !important;
}
.select .ant-select-selector .ant-select-selection-item img {
  display: none !important;
}
.select .ant-select-selector .ant-select-selection-item .select-none {
  min-height: 33px !important;
}
.select .ant-select-selector span {
  line-height: 50px !important;
  font-size: 16px !important;
}
.select .ant-select-multiple .ant-select-selection-item {
  min-height: 30px !important;
}
.select .ant-select-multiple .ant-select-selection-item span {
  min-height: 30px !important;
  line-height: 30px !important;
  font-size: 16px !important;
}

.input-error-text {
  font-size: 13px;
  color: rgb(243, 57, 57);
}`, "",{"version":3,"sources":["webpack://./src/component/Input/style.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,YAAA;EACA,sDAAA;EACA,kBAAA;EACA,0BAAA;AACJ;AAAI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAER;AAAI;EACI,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,uBAAA;AAER;AAAI;;EAEI,WAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;AAER;AAAI;EACI,iBAAA;EACA,iCAAA;AAER;AAAI;EACI,6CAAA;AAER;AAAI;EACI,4CAAA;AAER;AAAI;EACI,kBAAA;AAER;AAAI;EACI,uBAAA;EACA,iBAAA;AAER;;AACA;EACI,YAAA;EACA,iBAAA;EACA,iBAAA;AAEJ;AADI;EACI,YAAA;EACA,kBAAA;AAGR;;AACI;EACI,2BAAA;EACA,6BAAA;AAER;AAAY;EACI,wBAAA;AAEhB;AAAY;EACI,2BAAA;AAEhB;AACQ;EACI,4BAAA;EACA,0BAAA;AACZ;AAEI;EAMI,2BAAA;AALR;AAAQ;EACI,2BAAA;EACA,4BAAA;EACA,0BAAA;AAEZ;;AAGA;EACI,eAAA;EACA,uBAAA;AAAJ","sourcesContent":[".input {\n    display: flex;\n    border-radius: 3px;\n    height: 50px;\n    box-shadow: 0px 0px 1px 1px rgba(128, 128, 128, 0.253);\n    position: relative;\n    font-size: 16px !important;\n    .input-icon {\n        position: absolute;\n        right: 5px;\n        top: 12.5px;\n        height: 25px;\n        width: 25px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: grey;\n    }\n    .input-high {\n        background-color: hwb(228deg 92% 6%);\n        display: flex;\n        align-items: center;\n        width: 50px;\n        height: 50px;\n        border-radius: 3px 0px 0px 3px;\n        justify-content: center;\n    }\n    input,\n    textarea {\n        width: 100%;\n        padding: 0px 15px;\n        border: none;\n        outline: none;\n        font-size: 16px !important;\n    }\n    input::placeholder {\n        font-weight: bold;\n        color: rgba(128, 128, 128, 0.685);\n    }\n    .input-item:focus {\n        box-shadow: 0px 0px 1px 1px rgb(37, 130, 236);\n    }\n    .input-error {\n        box-shadow: 0px 0px 1px 1px rgb(243, 57, 57);\n    }\n    .input-item-borderRadius {\n        border-radius: 3px;\n    }\n    .input-item-green {\n        color: rgb(65, 158, 64);\n        font-weight: bold;\n    }\n}\n.input-area {\n    height: auto;\n    min-height: 120px;\n    max-height: 120px;\n    textarea {\n        resize: none;\n        padding: 10px 15px;\n    }\n}\n.select {\n    .ant-select-selector {\n        min-height: 50px !important;\n        border-radius: 3px !important;\n        .ant-select-selection-item {\n            img {\n                display: none !important;\n            }\n            .select-none {\n                min-height: 33px !important;\n            }\n        }\n        span {\n            line-height: 50px !important;\n            font-size: 16px !important;\n        }\n    }\n    .ant-select-multiple .ant-select-selection-item {\n        span {\n            min-height: 30px !important;\n            line-height: 30px !important;\n            font-size: 16px !important;\n        }\n        min-height: 30px !important;\n    }\n}\n.input-error-text {\n    font-size: 13px;\n    color: rgb(243, 57, 57);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
